import { TFunction } from 'i18next'
import { AddInterestPeriodRequest } from 'types/interest-periods/interest-periods-requests'
import * as z from 'zod'

export const createInterestRateForm = (t: TFunction): z.ZodSchema<AddInterestPeriodRequest> =>
    z
        .object({
            annualInterestRatePercentage: z.coerce
                .number()
                .gt(0, { message: t('TEXT_MORE_THAN', 'Must be more than {{nr}}', { nr: 0 }) })
                .lt(100, { message: t('TEXT_LESS_THAN', 'Must be less than {{nr}}', { nr: 100 }) }),
            startDate: z.coerce.date(),
            endDate: z.coerce.date(),
        })
        .refine((data) => data.endDate > data.startDate, {
            message: t('TEXT_END_DATE_MUST_BE_HIGHER', 'End date cannot be earlier than start date'),
            path: ['endDate'],
        })
